export * from './exchangeRates.service';
import { ExchangeRatesService } from './exchangeRates.service';
export const APIS = [ExchangeRatesService];
